// страница Обо мне

import React from "react";
import styled from "styled-components";

const AboutSection = styled.section`
  display: flex;
  max-width: 900px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 100vh;
  padding: 4rem 1.5rem; 
  overflow: hidden;

  /* Адаптивные отступы */
  @media (min-width: 640px) {
    padding-bottom: 0.875rem; 
    padding-top: 0.25rem; 
`;

// Контейнер для фонового изображения
const BackgroundContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  display: flex;
  justify-content: center;
`;

const BackgroundImage = styled.img`
  max-width: none;
  width: auto;
  height: 100%;
  object-fit: contain;
  object-position: top;

  position: relative;
  right: 0;
  margin-right: 0;
`;

// Контейнер для контента
const ContentWrapper = styled.div`
  /* Контейнер для центрирования карточки */
`;

// карточка с текстом
const ContentCard = styled.div`
  position: relative;
  z-index: 10;
  max-width: 42rem;
  padding: 1.5rem;
  border-radius: 1.2rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);

  background-color: rgba(255, 255, 255, 0.6);

  /* Добавляем эффект "айфона" glassmorphism или как его там ...*/
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);

  body.dark-theme & {
    background-color: rgba(26, 26, 26, 0.37);

    box-shadow: 0 10px 15px -3px rgba(255, 255, 255, 0.05),
      0 4px 6px -4px rgba(255, 255, 255, 0.05);
  }
`;

const Title = styled.h3`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  font-family: Philosopher;
  color: var(--color-text);
`;

const Paragraph = styled.p`
  line-height: 1.5;
  color: var(--color-text);
`;

export default function About() {
  return (
    <AboutSection id="about" className="section-padding">
      <BackgroundContainer>
        <BackgroundImage
          src="./images/aboutBackgr.png"
          alt="Decorative Background"
        />
      </BackgroundContainer>

      {/* контент поверх фона */}
      <ContentWrapper>
        <ContentCard>
          <Title>Обо мне</Title>
          <Paragraph>
            Frontend-разработка — это моя профессиональная страсть. Основной
            приоритет: чистый, структурированный код и безупречный
            пользовательский опыт. Владею HTML, CSS, JavaScript и React. Всегда
            готов к освоению новых технологий и быстрой адаптации под требования
            проекта. Активно изучаю React Native как следующий шаг в мобильной
            разработке.
          </Paragraph>
        </ContentCard>
      </ContentWrapper>
    </AboutSection>
  );
}
